import { useState, useEffect } from 'react';
import { Save, Eye, EyeOff, CheckCircle } from 'lucide-react';
import { useStore } from '../store';

export function SettingsPanel() {
  const { settings, setSettings } = useStore();
  const [apiKey, setApiKey] = useState(settings.deepseekApiKey);
  const [backendUrl, setBackendUrl] = useState(settings.backendUrl);
  const [model, setModel] = useState(settings.model);
  const [showKey, setShowKey] = useState(false);
  const [saved, setSaved] = useState(false);
  
  useEffect(() => {
    setApiKey(settings.deepseekApiKey);
    setBackendUrl(settings.backendUrl);
    setModel(settings.model);
  }, [settings]);
  
  const handleSave = () => {
    setSettings({
      deepseekApiKey: apiKey,
      backendUrl: backendUrl,
      model: model,
    });
    // Save to localStorage
    try {
      localStorage.setItem('vidclaw_settings', JSON.stringify({
        deepseekApiKey: apiKey,
        backendUrl: backendUrl,
        model: model,
      }));
    } catch {}
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };
  
  const models = [
    { value: 'seedance_2.0_fast', label: 'Seedance 2.0 Fast（快速）' },
    { value: 'seedance_2.0', label: 'Seedance 2.0（标准）' },
  ];
  
  return (
    <div className="h-full bg-surface-0 p-8 animate-fade-in">
      <div className="max-w-lg mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h2 className="text-lg font-semibold text-text-primary mb-1">设置</h2>
          <p className="text-sm text-text-muted">配置 API 和模型参数</p>
        </div>
        
        {/* Form */}
        <div className="space-y-6">
          {/* DeepSeek API Key */}
          <div>
            <label className="text-xs text-text-muted uppercase tracking-wider mb-2 block font-medium">
              DeepSeek API Key
            </label>
            <div className="relative">
              <input
                type={showKey ? 'text' : 'password'}
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                placeholder="sk-..."
                className="w-full bg-surface-1 border border-border rounded-xl px-4 py-3 text-sm text-text-primary placeholder-text-muted focus-brand transition-all pr-10"
              />
              <button
                onClick={() => setShowKey(!showKey)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted hover:text-text-secondary transition-colors"
              >
                {showKey ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            <p className="text-xs text-text-disabled mt-2">
              用于 AI 提示词改写，可从 deepseek.com 获取
            </p>
          </div>
          
          {/* Backend URL */}
          <div>
            <label className="text-xs text-text-muted uppercase tracking-wider mb-2 block font-medium">
              后端服务地址
            </label>
            <input
              type="text"
              value={backendUrl}
              onChange={(e) => setBackendUrl(e.target.value)}
              placeholder="http://localhost:3001"
              className="w-full bg-surface-1 border border-border rounded-xl px-4 py-3 text-sm text-text-primary placeholder-text-muted focus-brand transition-all"
            />
            <p className="text-xs text-text-disabled mt-2">
              即梦 CLI 后端服务地址
            </p>
          </div>
          
          {/* Model Selection */}
          <div>
            <label className="text-xs text-text-muted uppercase tracking-wider mb-2 block font-medium">
              默认模型
            </label>
            <div className="grid grid-cols-2 gap-3">
              {models.map((m) => (
                <button
                  key={m.value}
                  onClick={() => setModel(m.value)}
                  className={`
                    px-4 py-3 rounded-xl text-sm transition-all border
                    ${model === m.value
                      ? 'bg-brand/15 text-brand border-brand/20'
                      : 'bg-surface-1 text-text-secondary border-border hover:bg-surface-2 hover:text-text-primary'
                    }
                  `}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>
          
          {/* Save Button */}
          <button
            onClick={handleSave}
            className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-brand-gradient hover:shadow-[var(--shadow-brand)] text-white text-sm font-medium rounded-xl transition-all hover:-translate-y-0.5"
          >
            {saved ? (
              <>
                <CheckCircle size={16} />
                已保存
              </>
            ) : (
              <>
                <Save size={16} />
                保存设置
              </>
            )}
          </button>
        </div>
        
        {/* Footer hint */}
        <div className="mt-8 text-center">
          <p className="text-xs text-text-disabled">
            设置保存到浏览器本地存储，刷新页面后生效
          </p>
        </div>
      </div>
    </div>
  );
}